import React from 'react';
import { facilityProjectReportID, powerBIBase } from '../../../config/PowerBiReportConfig';
import { appBaseURL } from '../../../config/URLConfig';

export const FacilityReport = ({ username }) => {

    const handleViewReportClick = () => {
        window.open(`${powerBIBase}${facilityProjectReportID}/ReportSection`);
    }

    const handleDownloadExcelClick = () => {
        window.open(`${appBaseURL}/api/facility-report?username=${username}`);
    }

    return (
        <div>
            <h2 className="report-header">Facility Report</h2>
            <div className="report-button-container">
                <div className={ 'report-button' } onClick={ handleViewReportClick }>
                    Facility Report
                </div>
                <div className={ 'report-button' } onClick={ handleDownloadExcelClick }>
                    Download Excel
                </div>
            </div>
        </div>
    );
}
